<template>
  <el-pagination
    ref="pagination"
    style="padding-top:30px"
    :page-sizes="[15, 60, 100]"
    v-bind="$attrs"
    :layout="$attrs.layout || 'total, prev, pager, next, sizes, jumper'"
    :current-page="value.pageNo"
    :page-size="15"
    v-on="$listeners"
    @current-change="currentChange"
    @size-change="handleSizeChange"
  />
</template>

<script>
export default {
  name: 'base-pagination',
  props: {
    value: {
      type: [Object],
      default: function() {
        return {
          pageNo: 1,
          pageSize: 15
        };
      }
    }
  },
  methods: {
    currentChange(e) {
      this.$emit('input', { pageSize: this.value.pageSize, pageNo: e });
    },
    handleSizeChange(e) {
      this.$emit('input', { pageSize: e, pageNo: 1 });
    }
  }
};
</script>
